<template>
  <el-drawer
    title="知识产权声明"
    :visible.sync="drawerStatementVisible"
    direction="rtl"
    size="70%"
    @close="drawerStatementVisibleClose"
  >
    <div class="box">
      <p class="tAlign">"WoYou工资"知识产权声明</p>
      <p>一、内容归属和侵权担保</p>
      <p>
        1、【用户生成的内容归属】用户使用瑞启及瑞启关联方提供的服务时上传、发布的内容（包括但不限于图片、评论、文章、音频、视频，下同）的知识产权均归用户本人或原始著作权人所有。用户应保证上传、发布的内容均属原创或已获得合法授权，因侵犯他人知识产权而引发纠纷的，用户须自行承担全部责任，瑞启及瑞启关联方对上述纠纷免责，若造成瑞启及瑞启关联方损失的，瑞启及瑞启关联方有权按照法律规定索赔以维护合法权益。在法律允许的范围内，瑞启及瑞启关联方保留删除平台内各类不符合规定的点评信息或者其他任何信息而不通知用户的权利。
      </p>
      <p>
        2、【瑞启及瑞启关联方的内容归属】若无特别说明或者法律特别规定，瑞启及瑞启关联方在平台及相关服务中提供的内容（包括但不限于产品、技术、程序、软件、网页、文字、图片、音频、视频、榜单、版面设计、数据、信息等）的知识产权归属瑞启及瑞启关联方。
      </p>
      <p>二、用户内容给瑞启及瑞启关联方的授权</p>
      <p>
        1、用户通过瑞启及瑞启关联方平台上传、发布的内容（包括但不限于图片、评论、文章、音频、视频等），授予瑞启及瑞启关联方免费的、永久的、不可撤销的、全球范围内的、可转授权的独家许可（包括但不限于复制权、信息网络传播权、改编权、汇编权、修改权、翻译权、制作衍生品、表演和展示等）。
      </p>
      <p>
        2、除瑞启及瑞启关联方另有书面声明或法律有特别规定外，用户通过瑞启及瑞启关联方平台发布的信息一经发布即向公众传播，且用户保证不会将已发表于瑞启及瑞启关联方平台的任何内容和信息，以任何形式发布或授权其它第三方使用。若第三方侵犯前述知识产权，瑞启及瑞启关联方有权单独采取各种措施追究第三方的法律责任（包括但不限于以瑞启及瑞启关联方的名义独立进行侵权取证、提起诉讼或仲裁、调解、和解等）。
      </p>
      <p>三、禁止行为</p>
      <p>
        除法律特别规定或者政府明确要求外，在未取得瑞启及瑞启关联方书面明确许可前，任何单位或者个人不得将瑞启及瑞启关联方的任何知识产权对象进行任何目的的使用，任何单位或个人不得以任何方式对瑞启及瑞启关联方平台上的任何内容和信息作全部和局部的复制、转载、引用和链接，任何单位或者个人不得以任何方式引诱、要求瑞启及瑞启关联方注册用户或者第三方复制转载瑞启及瑞启关联方平台内容或者同意该单位或者个人复制转载瑞启及瑞启关联方平台内容，亦不得通过技术手段扫描、探测、抓取瑞启及瑞启关联方平台内容。任何注册用户将在瑞启及瑞启关联方注册用户名和密码提供给任何第三方用于许可其复制瑞启及瑞启关联方平台内容的，将构成对《瑞启及瑞启关联方平台用户服务协议》的违反，并可能导致其账户被关闭或者处罚。任何违反本知识产权声明的行为，瑞启及瑞启关联方保留追究行为人法律责任的权利。
      </p>
      <p>四、侵权投诉指引</p>
      <p>
        瑞启及瑞启关联方重视知识产权保护，反对侵犯知识产权的行为。若权利人认为瑞启及瑞启关联方平台中其他用户或商户发布的内容侵犯自身的知识产权或其他合法权益的，可以通过“瑞启及瑞启关联方知识产权维权平台”或客服中心进行投诉，权利人可使用或注册瑞启及瑞启关联方账号登录“瑞启及瑞启关联方知识产权维权平台”，权利人依据该平台公示的相关投诉规则提交合格的证据资料后，瑞启及瑞启关联方将依据相应的法律法规进行处理。
      </p>
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      drawerStatementVisible: false,
    };
  },
  methods: {
    drawerStatementVisibleClose() {
      this.$emit("close");
    },
  },
  watch: {
    visible(val) {
      this.drawerStatementVisible = val;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 25px;
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>